declare var window:any;

// export default {
//     delHandle: function(list:any,str:any){
//         if (typeof str == "string"){
//             list.forEach(function(item:HTMLElement){
//                 item.classList.remove(str);
//             })
//         }
//     }
// }


export const _base = function() {
    window.delHandle = function(list:any,str:any){
        if (typeof str == "string"){
            list.forEach(function(item:HTMLElement){
                item.classList.remove(str);
            })
        }
    }
    window.getParameters = function () {
		let urlSearchParams = new URLSearchParams(window.location.search);
		let params = Object.fromEntries(urlSearchParams.entries());

		return params;
	};

	window.getQueryString = function (params: any) {
		var str = Object.keys(params)
			.map(function (key) {
				return key + "=" + params[key];
			})
			.join("&");
		return str;
	};

    window.setPushState = function(name:any, value:any,url:any){
        let params = window.getParameters();
        params[name] = value;
        let queryStr = window.getQueryString(params);
        window.history.pushState("", "", "?" + queryStr);
    }
}